import { Action } from '@ngrx/store';
import { AccesoEmail, AccesoEmailMarkable, EmailSelected } from 'src/common/acceso';


export enum EmailActionTypes {
	EmailsRequested = "[Email Component] Emails Requested",
	EmailsLoaded = "[Acceso API] Emails Loaded",
    EmailsCancelled = "[Acceso API] Emails Loaded",
	EmailsRight = '[Acceso API] Emails Right',
	EmailToggleRequested = "[Email Component] Email Toggle Requested",

	EmailToggleMarkedRequested = '[Email Toggle Marked Requested] Email Toggle Marked Requested',
	EmailToggleMarkedLoaded = '[Email Toggle Marked Loaded] Email Toggle Marked Loaded',
	EmailToggleMarkedCancelled = '[Email Toggle Marked Cancelled] Email Toggle Marked Cancelled',

	EmailFavInit = '[Main Component] Email Fav Init',

	EmailAccesoRequested = "[Email Access] Email Acceso Requested",
	EmailAccesoLoaded = "[Acceso API] Email Acceso Loaded",
	EmailAccesoCancelled = "[Acceso API] Email Acceso Cancelled"
}

export class EmailsRequested implements Action {
	readonly type: string = EmailActionTypes.EmailsRequested;
	constructor() {
	}
}

export class EmailsLoaded implements Action {
	readonly type: string = EmailActionTypes.EmailsLoaded;
	constructor( public payload: { personal: AccesoEmail, delegados: AccesoEmailMarkable[] } ) {
	}
}

export class EmailsCancelled implements Action {
	readonly type: string = EmailActionTypes.EmailsCancelled;
	constructor() {
	}
}

export class EmailsRight implements Action {
	readonly type: string = EmailActionTypes.EmailsRight;
	constructor() {
	}
}

export class EmailToggleRequested implements Action {
	readonly type: string = EmailActionTypes.EmailToggleRequested;
	constructor() {
	}
}

export class EmailToggleMarkedRequested implements Action {
	readonly type: string = EmailActionTypes.EmailToggleMarkedRequested;
	constructor( public payload: AccesoEmailMarkable ) {
	}
}

export class EmailToggleMarkedLoaded implements Action {
	readonly type: string = EmailActionTypes.EmailToggleMarkedLoaded;
	constructor( public payload: number ) {
	}
}

export class EmailToggleMarkedCancelled implements Action {
	readonly type: string = EmailActionTypes.EmailToggleMarkedCancelled;
	constructor( public payload: number ) {
	}
}

export class EmailFavInit implements Action {
	readonly type: string = EmailActionTypes.EmailFavInit;
	constructor() {
	}
}

export class EmailAccesoRequested implements Action {
	readonly type: string = EmailActionTypes.EmailAccesoRequested;
	constructor( public payload: EmailSelected ) {
	}
}

export class EmailAccesoLoaded implements Action {
	readonly type: string = EmailActionTypes.EmailAccesoLoaded;
	constructor() {
	}
}

export class EmailAccesoCancelled implements Action {
	readonly type: string = EmailActionTypes.EmailAccesoCancelled;
	constructor() {
	}
}

export type EmailActions = EmailsRequested | EmailsCancelled | EmailsLoaded | EmailToggleRequested |
	EmailToggleMarkedRequested | EmailToggleMarkedLoaded | EmailToggleMarkedCancelled |
	EmailFavInit | EmailAccesoRequested | EmailAccesoLoaded | EmailAccesoCancelled;